export const HOME_PAGE_MAX_WIDTH = 1120;
